import { IsString } from 'class-validator';

export class LoginModel {
  @IsString()
  declare email: string;

  @IsString()
  declare password: string;
}
